import React, { useEffect } from 'react'
import EventCard from './EventCard/EventCard'
import SingleEvent from './SingleEvent/SingleEvent'

const EventList = ({events,selectedEvent,
  setSelectedEvent,
  currentEvent,
  setCurrentEvent}) => {
  
    useEffect(() => {
   

    }, [events])
    
    return (
      <>
        {selectedEvent ? (
          <SingleEvent currentEvent={currentEvent} />
        ) : (
          <div className='grid grid-cols-1 sm:grid-cols-4 gap-8 p-8'>
            {events && events.map((e, i) => (
              <EventCard
                key={i}
                setCurrentEvent={setCurrentEvent}
                setSelectedEvent={setSelectedEvent}
                titre={e.title}
                description={e.description}
                galery={e.photoGallery}
                date={e.date}
                cover={e.coverPhoto.asset._ref}
              />
            ))}
          </div>
        )}
      </>
    );
    
}

export default EventList